import { render } from "./purchase-table.vue?vue&type=template&id=f196dfb8&scoped=true"
import script from "./purchase-table.vue?vue&type=script&lang=ts"
export * from "./purchase-table.vue?vue&type=script&lang=ts"

import "./purchase-table.vue?vue&type=style&index=0&id=f196dfb8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f196dfb8"

export default script